export interface RecipientListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  partner_id?: number[] | null;
  sender_id?: number[] | null;
  search?: string | null;
}

export const defaultRecipientListFilter: RecipientListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  partner_id: null,
  sender_id: null,
  search: '',
};
